import styled from 'styled-components'

import { breakpoint } from 'style/theme'

export default styled.div`
  .title {
    text-align: center;
    font-size: 36px;
  }
  .step-block {
    margin-top: 40px;
    .step-image {
      display: flex;
      justify-content: center;
      .step-image-desktop {
        img {
          aspect-ratio: 1442 / 432;
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .title {
      font-size: 20px;
    }
    .step-block {
      margin-top: 20px;
      .step-image {
        display: flex;
        justify-content: center;

        .step-image-mobile {
          img {
            aspect-ratio: 360 / 223;
          }
        }
      }
    }
  }
`
